<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="msgBox" v-if="addType">
        <div class="contv">
          <form class="form">
            <div class="write-txt">
              <p class="write-title">名称：<span>*</span></p>
              <div class="write-text">
                <!-- <textarea placeholder="" v-model="addObj.name"></textarea> -->
                 <input type="text" v-model="addObj.name">
              </div>
            </div>
            
            <div class="write-txt">
              <p class="write-title">类型：<span>*</span></p>
              <div class="write-text">
                <el-select v-model="addObj.type" placeholder="请选择">
                  <el-option
                    v-for="item in typelist"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="write-txt" v-if="addObj.type!=3">
              <p class="write-title">等级：<span>*</span></p>
              <div class="write-text">
                 <input type="number" v-model="addObj.level">
                 <!-- <el-select v-model="addObj.level" placeholder="请选择">
                  <el-option
                    v-for="item in 9"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select> -->
              </div>
            </div>
          </form>
          <div class="btnBox">
              <button class="btn btn-save" @click="saveSub">保存</button>
              <button class="btn btn-close" @click="closeSub">取消</button>
            </div>
        </div>
      </div>

      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <p>添加</p>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.id">{{item.id}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.type==1?'实词/虚词':item.type==2?'古诗文':'英语'">{{item.type==1?'实词/虚词':item.type==2?'古诗文':'英语'}}</p>
              <p :title="item.add_time">{{item.create_time}}</p>
              <p class="btnList">
                <button title="编辑" class="btn btn-revise" @click="buildSub(item)">编辑</button>
                <!-- <button title="删除" style="color: #FF1919;" class="btn btn-remove" @click="removeShow(item)">删除</button> -->
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="removeHide">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGradeList,saveGrade ,getUploadToken,getLibraryDetail,delLibrary,saveReview ,updateLibraryStatus} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "resource",
  data() {
    return {
      navId:'6',
      childrenID:'',
      titleList:[
        {id:1,title:'ID'},
        {id:2,title:'名称'},
        {id:3,title:'类型'},
        {id:4,title:'添加时间'},
        {id:5,title:'操作'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        name:'',
        type:1,
        level:''
      },
      totalPage:0,
      removeID:'',
      url:'',
      typelist:[
        {id:1,title:'实词/虚词'},
        {id:2,title:'古诗文'},
        {id:3,title:'英语'},
      ],
      reviewType:false,
      imgType:false,
      uploadObj: {
        token: "",
        key: "",
      },
      dialogVisible:false,
      reviewObj:{
        id:'',
        review:[]
      },
      reviewList:[
        {num:'',type:''}
      ]
    };
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.childrenID = this.$refs.navBox.childrenID = this.$route.query.id;
    this.$refs.navBox.navChange();
    console.log(this.$refs.navBox)
    this.getList();
    this.getToken();
  },
  components: {
    navBox,
    myHeader
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getToken(){
      var that = this;
      try {
        const response = await getUploadToken(this.obj,this.token);
        if(response.code == 200){
          that.uploadObj.token = response.data.token;   
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async getList(){
      var that = this;
      try {
        const response = await getGradeList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
    },

    buildSub(e){
      var that = this;
      if(e.type == 3){
        this.addObj = {
          name:e.name,
          type:e.type,
          id:e.id
        }
      } else {
        this.addObj = {
          name:e.name,
          type:e.type,
          level:e.level,
          id:e.id
        }
      }
      that.addType = 'edit';
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delLibrary({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.removeType = false;
          that.removeID = '';
          that.getList();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeHide(){
      var that = this;
      that.removeType = false;
      that.removeID = '';
    },

    async saveSub(){
      var that = this;
      if(this.addObj.name == ''){
        that.$message('请输入资源名称！');
        return false;
      }
      try {
        const response = await saveGrade(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async switchChange(e){
      var that = this;
      var obj = {
        id:e.id,
        status:e.status==false?0:1,
      };
      try {
        const response = await updateLibraryStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
          that.getList();      
        } else {
          that.$message(response.msg);
          e.status = !e.status;
        }
      } catch (error) {
        that.$message(error);
        e.status = !e.status;
      }
    },

    closeSub(){
      this.addType = '';
      this.reviewType = false;
      this.addObj = {
        name:'',
        type:1,
      }
      this.reviewObj={
        id:'',
        review:[]
      };
      this.reviewList=[
        {num:'',type:''}
      ]
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.addObj.image = '';
    },

    beforeUploadImg(file) {
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleSuccessImg(response, file, fileList,index,type,num) {
      var that = this;
      that.addObj.image = response.key;
      that.$forceUpdate();
      that.loading = false;
      that.uploadObj.key = "";
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    handleRemoveImg() {
      this.uploadUrl = "";
      this.addObj.image = "";
    },

    async reviewShow(e){
      var that = this;
      this.reviewObj.id = e.id;
      try {
        const response = await getLibraryDetail({id:e.id},this.token);
        if(response.code == 200){
          if(response.data.review){
            var data = JSON.parse(JSON.stringify(response.data.review))
            that.reviewList = [];
            data.forEach(function(item,index){
              if(item.indexOf('d') > -1){
                that.reviewList.push({num:item.split('d')[0],type:'d'})
              }
              if(item.indexOf('m') > -1){
                that.reviewList.push({num:item.split('m')[0],type:'m'})
              }
              if(item.indexOf('y') > -1){
                that.reviewList.push({num:item.split('y')[0],type:'y'})
              }
            });
          } else {
            that.reviewList = [
              {num:'',type:''}
            ];
          }
          that.reviewType = true;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addReview(){
      this.reviewList.push({num:'',type:''});
    },

    removeReviewType(index){
      this.reviewList.splice(index,1);
    },

    async reviewSub(){
      var that = this;
      this.reviewList.forEach(function(item,index){
        that.reviewObj.review.push(item.num+item.type)
      })
      try {
        const response = await saveReview(this.reviewObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();     
          that.reviewType = false;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    reviewHide(){
      this.reviewList = [
        {num:'',type:''}
      ];
      this.reviewType = false;
    },

    contentShow(e){
      // if(e.type == 3){
      //   this.$router.push('/english?type='+e.type+'&id='+e.id);
      //   return false;
      // } else if(e.type == 2){
      //   this.$router.push('/exam?type='+e.type+'&id='+e.id);
      //   return false;
      // } else {
      //   this.$router.push('/content?type='+e.type+'&id='+e.id+'&lid='+e.id);
      // }
      if(this.childrenID == '1-1'){
        this.$router.push('/content?type='+e.type+'&lid='+e.id);
      } else if(this.childrenID == '1-2'){
        this.$router.push('/exam?type='+e.type+'&lid='+e.id);
      } else {
        this.$router.push('/english?type='+e.type+'&lid='+e.id);
      }
    }
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 5 );
  }

  .dataList .listItem p.btnList{
    font-size: 0;
  }

  .btnList .btn{
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    color: #333333;
    margin: 0 20px 0 0;
    text-align: left;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }
  
  .MobelBox input{
    height: 45px;
    width: 200px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .write-btnBox .btn{
    width: 145px;
    height: 51px;
    line-height: 51px;
    border-radius: 8px;
    color: #fff;
    background-color: #00C7A3;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 80px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.write-txt>>> .el-radio__inner{
  width: 20px;
  height: 20px;
}

.write-txt>>> .el-radio__inner::after{
  width: 10px;
  height: 10px;
}

.reviewBox .write-text input,
.write-txt>>> .el-radio-group{
  display: inline-block;
  vertical-align: middle;
}

.reviewBox .write-text input{
  margin-right: 20px;
}

.reviewBox .btn-add{
  font-size: 18px;
  color: #00C7A3;
  border-radius: 6px;
  padding: 6px 24px;
  box-sizing: border-box;
  display: block;
  margin-top: 37px;
  border: solid 1px #00C7A3;
}


.MobelBox .write-text .btn.btn-review-remove{
  color: #fff;
  font-size: 18px;
  background-color: #F26060;
  border-radius: 6px;
  height: 36px;
  line-height: 36px;
  margin-left: 30px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0px 36px;
  display: inline-block;
  vertical-align: top;
  margin-left: 30px;
}

.content>>> .el-radio__input.is-checked .el-radio__inner{
  background-color: #00C7A3;
  border-color: #00C7A3;
}
.content>>> .el-radio__input.is-checked+.el-radio__label{
  color: #00C7A3;
}
.content>>> .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #00C7A3;
}
</style>



// WEBPACK FOOTER //
// src/grade/index.vue